import { PagenatedResponse } from '@models/common';
import { AffiliateListItem, AffiliateSearchQuery } from '@models/affiliate';
import { apiClient } from '.';

const BASE_URL = '/admin/v1/affiliates';

export const searchAffiliates = async (query: AffiliateSearchQuery) => {
  const { data } = await apiClient.get<PagenatedResponse<AffiliateListItem>>(BASE_URL, {
    params: query,
  });
  return data;
};

export const downloadAffiliatesExcel = async (query: AffiliateSearchQuery) => {
  return apiClient.get(`${BASE_URL}/export`, {
    params: query,
    responseType: 'blob',
    headers: { 'Cache-Control': 'no-cache' },
  });
};

export const updateAffiliateStatus = async ({
  affiliateId,
  isActive,
}: {
  affiliateId: string;
  isActive: boolean;
}): Promise<{
  success: boolean;
  affiliateId: string;
  isActive: boolean;
  deactivatedAt?: Date;
}> => {
  const { data } = await apiClient.patch<{
    success: boolean;
    affiliateId: string;
    isActive: boolean;
    deactivatedAt?: Date;
  }>(`${BASE_URL}/${affiliateId}/status`, { isActive });
  return data;
};
